
import portfolio_one from "../images/slides/portfolio_one.png"
import portfolio_two from "../images/slides/portfolio_two.png"
import quiz_slide from "../images/slides/quiz_slide.png"


const carouselDummy = [
    {
        "slide_img": quiz_slide,
        "slide_heading": "Take a quiz!",
        "slide_description": "Learn and earn $CKB"
    },
    {
        "slide_img": portfolio_two,
        "slide_heading": "Portfolio",
        "slide_description": "Track your trades in one place, not all over the place"
    },
    {
        "slide_img": portfolio_one,
        "slide_heading": "Portfolio 🔥",
        "slide_description": "Track your trades in one place, not all over the place"
    }
]

export default carouselDummy;